import Finished from './views/finished';

export default{
  views: Finished,
};
